var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"to_view_more center margin_auto",on:{"click":_vm.jump1}},[_vm._v("查看更多")])}
var staticRenderFns = []

export { render, staticRenderFns }